"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("redux-persist/constants");
var effects_1 = require("redux-saga/effects");
var Immutable = require("seamless-immutable");
var typescript_fsa_1 = require("typescript-fsa");
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var analytics = require("../infra/analytics");
var firebase = require("../infra/firebase");
var articles = require("./articles");
var books = require("./books");
var environment = require("./environment");
var message = require("./message");
var settings = require("./settings");
var tasks = require("./tasks");
var utils = require("./utils");
var videos = require("./videos");
var actionCreator = typescript_fsa_1.default("AUTHENTICATION");
var deleteAccount = actionCreator("DELETE_ACCOUNT");
var setSignInState = actionCreator("SET_SIGN_IN_STATE");
var signIn = actionCreator.async("SIGN_IN");
var signOut = actionCreator("SIGN_OUT");
exports.actionCreators = {
    deleteAccount: deleteAccount,
    setSignInState: setSignInState,
    signIn: function () { return signIn.started(null); },
    signOut: signOut,
};
exports.signInActions = signIn;
exports.initialState = Immutable({ rehydrated: false, signedIn: null });
var subReducer = typescript_fsa_reducers_1.reducerWithInitialState(exports.initialState)
    .case(setSignInState, function (state, signedIn) { return state.merge({ signedIn: signedIn }); });
function reducer(state, action) {
    if (state === void 0) { state = exports.initialState; }
    if (action.type === constants_1.REHYDRATE) {
        return state.merge({ rehydrated: true });
    }
    return subReducer(state, action);
}
exports.reducer = reducer;
function initialize() {
    var _a, rehydrated, signedIn;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (_a) {
                    var authentication = _a.authentication;
                    return authentication;
                })];
            case 1:
                _a = _b.sent(), rehydrated = _a.rehydrated, signedIn = _a.signedIn;
                if (!(rehydrated && signedIn)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.all([
                        effects_1.put(articles.actionCreators.getItems()),
                        effects_1.put(articles.actionCreators.getTrendingItems()),
                        effects_1.put(books.actionCreators.getItems()),
                        effects_1.put(books.actionCreators.getTrendingItems()),
                        effects_1.put(environment.actionCreators.getCountry()),
                        effects_1.put(tasks.actionCreators.getItems()),
                        effects_1.put(tasks.actionCreators.getTags()),
                        effects_1.put(videos.actionCreators.getItems()),
                        effects_1.put(videos.actionCreators.getTrendingItems()),
                        effects_1.put(settings.actionCreators.checkNotificationPermission()),
                    ])];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
exports.sagas = [
    utils.takeEvery(deleteAccount, function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.call(firebase.deleteAccount)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }),
    effects_1.takeEvery(constants_1.REHYDRATE, initialize),
    utils.takeEvery(setSignInState, initialize),
    utils.takeEvery(signIn.started, function _() {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 8]);
                    return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Signing in...", { temporary: false }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.call(firebase.signIn)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(signIn.done({ params: null, result: null }))];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(message.actionCreators.clearMessage())];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 5:
                    error_1 = _a.sent();
                    return [4 /*yield*/, effects_1.put(signIn.failed({ params: null, error: error_1 }))];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Could not sign in.", { error: true }))];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }),
    utils.takeEvery(signOut, function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.call(firebase.signOut)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }),
];
function storeInitializer(store) {
    var _this = this;
    firebase.onAuthStateChanged(function (user) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (user === null) {
                store.dispatch(setSignInState(false));
            }
            else {
                analytics.setUserId(user.uid);
                store.dispatch(setSignInState(true));
            }
            return [2 /*return*/];
        });
    }); });
}
exports.storeInitializer = storeInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/redux/authentication.ts
// module id = 146
// module chunks = 0